import useI18n from '@app/shared/vue/composables/use-I18n'

// Every string the drawer renders lives under one scope, so components ask for
// the leaf key and nothing repeats the prefix.
export const useColumnEditorI18n = (): ((
  key: string,
  options?: Record<string, unknown>
) => string) => {
  const I18n = useI18n()

  return (key: string, options?: Record<string, unknown>): string =>
    I18n.t(`reports.column_editor.${key}`, options)
}
